import {HomeFormSchema, HomeFormValues} from '@/forms/HomeForm'
import {FormRequest} from '@/services/api/forms'
import {Form, Formik, FormikHelpers} from 'formik'
import {toast} from 'react-hot-toast'
import CustomToast from '../CustomToast'
import {useMutation} from 'react-query'
import SubmitButton from './SubmitButton'
import TextArea from './TextArea'
import TextInput from './TextInput'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

interface Props {
  title: string;
  description: string;
}
export default function HomeRequestForm({title,description}: Props) {
  const {locale} = useRouter();
  const {t} = useTranslation('common');
  const mutation = useMutation(FormRequest)
  const handleSubmit = async (
    values: HomeFormValues,
    actions: FormikHelpers<HomeFormValues>,
  ) => {
    const data = mutation.mutate(values, {
      onSuccess(data: any) {
        actions.resetForm()
        toast.custom((tel) => <CustomToast t={tel} message={`${t('requestSuccessMessage')}`} type='success' />, 
        {
          duration: 4000,
        });
      },
      onError(error: any) {
        toast.custom((t) => <CustomToast t={t} message={error.response.data.message} type='error' />, 
        {
          duration: 4000,
          id: 'Validation Error'
        });
      },
    })
  }
  return (
    <div className="mt-6 md:mt-0" dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}>
      <div className={`${locale == 'ar' ? 'm-4' : ''}`}>
        <h1 className="text-success font-semibold text-3xl mb-3">
          {title}
        </h1>
        <p className="font-light text-text-color mt-2">
          {description}
        </p>
      </div>

      <Formik
        initialValues={{
          name: '',
          email: '',
          phone: '',
          num_of_stories: '',
          notes: '',
        }}
        validationSchema={HomeFormSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleSubmit}>
        {({errors, touched, values, setFieldValue, setFieldError}) => (
          <Form>
            <div className="mt-3 flex flex-col justify-between ">
              <TextInput
                label={t('nameLabel')}
                type="text"
                name="name"
                placeholder={t('namePlaceholder')}
                isError={errors.name && touched.name}
                error={errors.name}
                dir={locale === 'ar' ? 'rtl' : 'ltr'}
              />
            </div>

            <div className="mt-3 flex flex-col justify-between ">
              <TextInput
                label={t('emailLabel')}
                type="text"
                name="email"
                placeholder={t('emailPlaceholder')}
                isError={errors.email && touched.email}
                error={errors.email}
                dir={locale === 'ar' ? 'rtl' : 'ltr'}
              />
            </div>

            <div className="mt-3 flex flex-col justify-between ">
              <TextInput
                label={t('phoneLabel')}
                type="text"
                name="phone"
                placeholder={t('phoneLabel')}
                isError={errors.phone && touched.phone}
                error={errors.phone}
                dir={locale === 'ar' ? 'rtl' : 'ltr'}
              />
            </div>

            <div className="mt-3 flex flex-col justify-between ">
              <TextInput
                label={t('noOfStoriesLabel')}
                type="text"
                name="num_of_stories"
                placeholder={t('noOfStoriesPlaceholder')}
                isError={errors.num_of_stories && touched.num_of_stories}
                error={errors.num_of_stories}
                dir={locale === 'ar' ? 'rtl' : 'ltr'}
              />
            </div>

            <div className="mt-3 flex flex-col justify-between ">
              <TextArea
                label={t('notesLabel')}
                type="text"
                name="notes"
                placeholder={t('notesPlaceholder')}
                rows={4}
                isError={errors.notes && touched.notes}
                error={errors.notes}
                dir={locale === 'ar' ? 'rtl' : 'ltr'}
              />
            </div>
            <SubmitButton text={`${t('submitRequestForm')}`} isLoading={mutation.isLoading} textType="string" />
          </Form>
        )}
      </Formik>
    </div>
  )
}
